import { Injectable } from '@angular/core';
import { WindowReferenceService } from '../win-reference/window-reference.service';
import { DataLayer } from 'src/app/interfaces/dataleyer';

@Injectable({
  providedIn: 'root'
})
export class DataLayerService {

  private window;

  constructor(private _windowRef: WindowReferenceService) {
    this.window = _windowRef.nativeWindow; // intialise the window to what we get from our window service
  }

  private pingHome(obj: DataLayer) {
    if (obj) this.window.dataLayer.push(obj);
  }

  logPageLoad(event: string, ecom_tipo: string, ecom_pantalla: string, user_id: string) {
    const hit = {
      event: event,
      ecom_tipo: ecom_tipo,
      ecom_pantalla: ecom_pantalla,
      user_id: user_id
    }
    this.pingHome(hit);
  }

  logEvent(event: string, ecom_tipo: string, ecom_pantalla: string, user_id: string) {
    const hit = {
      event: event,
      ecom_tipo: ecom_tipo,
      ecom_pantalla: ecom_pantalla,
      user_id: user_id
    }
    console.log(' hit', JSON.stringify);
    this.pingHome(hit);
  }

  logArriendo(event: string, ecom_tipo: string, ecom_pantalla: string, user_id: string,
    valor_arriendo: string, valor_administracion: string, uso_inmueble: string,
    departamento: string, ciudad_inmueble: string) {
    const hit = {
      event: event,
      ecom_tipo: ecom_tipo,
      ecom_pantalla: ecom_pantalla,
      user_id: user_id,
      valor_arriendo: valor_arriendo,
      valor_administracion: valor_administracion,
      uso_inmueble: uso_inmueble,
      departamento: departamento,
      ciudad_inmueble: ciudad_inmueble
    }
    this.pingHome(hit);
  }

  logDuracion(event: string, ecom_tipo: string, ecom_pantalla: string, user_id: string,
    valor_arriendo: string, valor_administracion: string, uso_inmueble: string,
    departamento: string, ciudad_inmueble: string, tiempo_contratación: string,
    fecha_inicio_contrato: string) {
    const hit = {
      event: event,
      ecom_tipo: ecom_tipo,
      ecom_pantalla: ecom_pantalla,
      user_id: user_id,
      valor_arriendo: valor_arriendo,
      valor_administracion: valor_administracion,
      uso_inmueble: uso_inmueble,
      departamento: departamento,
      ciudad_inmueble: ciudad_inmueble,
      tiempo_contratación: tiempo_contratación,
      fecha_inicio_contrato: fecha_inicio_contrato
    }
    this.pingHome(hit);
  }

  logPlanes(event: string, ecom_tipo: string, ecom_pantalla: string, user_id: string,
    valor_arriendo: string, valor_administracion: string, uso_inmueble: string,
    departamento: string, ciudad_inmueble: string, tiempo_contratación: string,
    fecha_inicio_contrato: string, Plan: string, precio_plan: string, Servicio_publico: string,
    asistencia_seleccionado: string) {
    const hit = {
      event: event,
      ecom_tipo: ecom_tipo,
      ecom_pantalla: ecom_pantalla,
      user_id: user_id,
      valor_arriendo: valor_arriendo,
      valor_administracion: valor_administracion,
      uso_inmueble: uso_inmueble,
      departamento: departamento,
      ciudad_inmueble: ciudad_inmueble,
      tiempo_contratación: tiempo_contratación,
      fecha_inicio_contrato: fecha_inicio_contrato,
      Plan: Plan,
      precio_plan: precio_plan,
      Servicio_publico: Servicio_publico,
      asistencia_seleccionado: asistencia_seleccionado
    }
    this.pingHome(hit);
  }

  logDatosInmueble(event: string, ecom_tipo: string, ecom_pantalla: string, user_id: string,
    valor_arriendo: string, valor_administracion: string, uso_inmueble: string,
    departamento: string, ciudad_inmueble: string, tiempo_contratación: string,
    fecha_inicio_contrato: string, Plan: string, precio_plan: string, Servicio_publico: string,
    asistencia_seleccionado: string, matricula_inmobiliaria: string) {
    const hit = {
      event: event,
      ecom_tipo: ecom_tipo,
      ecom_pantalla: ecom_pantalla,
      user_id: user_id,
      valor_arriendo: valor_arriendo,
      valor_administracion: valor_administracion,
      uso_inmueble: uso_inmueble,
      departamento: departamento,
      ciudad_inmueble: ciudad_inmueble,
      tiempo_contratación: tiempo_contratación,
      fecha_inicio_contrato: fecha_inicio_contrato,
      Plan: Plan,
      precio_plan: precio_plan,
      Servicio_publico: Servicio_publico,
      asistencia_seleccionado: asistencia_seleccionado,
      matricula_inmobiliaria: matricula_inmobiliaria
    }
    this.pingHome(hit);
  }


  logDatos(event: string, ecom_tipo: string, ecom_pantalla: string, user_id: string,
    valor_arriendo: string, valor_administracion: string, uso_inmueble: string,
    departamento: string, ciudad_inmueble: string, tiempo_contratación: string,
    fecha_inicio_contrato: string, Plan: string, precio_plan: string, Servicio_publico: string,
    asistencia_seleccionado: string, pais_nacimiento: string, matricula_inmobiliaria: string) {
    const hit = {
      event: event,
      ecom_tipo: ecom_tipo,
      ecom_pantalla: ecom_pantalla,
      user_id: user_id,
      valor_arriendo: valor_arriendo,
      valor_administracion: valor_administracion,
      uso_inmueble: uso_inmueble,
      departamento: departamento,
      ciudad_inmueble: ciudad_inmueble,
      tiempo_contratación: tiempo_contratación,
      fecha_inicio_contrato: fecha_inicio_contrato,
      Plan: Plan,
      precio_plan: precio_plan,
      Servicio_publico: Servicio_publico,
      asistencia_seleccionado: asistencia_seleccionado,
      pais_nacimiento: pais_nacimiento,
      matricula_inmobiliaria: matricula_inmobiliaria
    }
    this.pingHome(hit);
  }

  logDataNewFlow(event: string, 
    ecom_tipo: string, 
    ecom_pantalla: string, 
    ecom_item: string, 
    user_id: string,
    additionalData?: Record<string, string>) {
    const hit = {
      event: event,
      ecom_tipo: ecom_tipo,
      ecom_pantalla: ecom_pantalla,
      ecom_item: ecom_item,
      user_id: user_id,
      ...additionalData
    }
    this.pingHome(hit);
  }

  logPlanesNewFlow(
    event: string,
    ecom_tipo: string,
    ecom_pantalla: string,
    ecom_item: string,
    user_id: string,
    plan_seleccionado: string,
    precio_plan: string,
    validacion: boolean,
    additionalData?: Record<string, string>) {
    const hit = {
      event,
      ecom_tipo,
      ecom_pantalla,
      ecom_item,
      user_id,
      plan_seleccionado,
      precio_plan,
      validacion,
      ...additionalData
    };
    this.pingHome(hit);
  }

  logCotizacion(event: string,
    ecom_tipo: string, 
    ecom_pantalla: string, 
    ecom_item: string, 
    user_id: string,
    valor_canon: string,
    valor_admin: string,
    uso_propiedad: string,
    validacion: boolean) {
    const hit = {
      event: event,
      ecom_tipo: ecom_tipo,
      ecom_pantalla: ecom_pantalla,
      ecom_item: ecom_item,
      user_id: user_id,
      valor_canon: valor_canon,
      valor_admin: valor_admin,
      uso_propiedad: uso_propiedad,
      validacion: validacion
    }
    this.pingHome(hit);
  }

  getLocalStorage(): number {
 
    return Number(localStorage.getItem('session_id'))
  }


}

